"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var typography_1 = require("../../typography");
var RADIO_SIZE = 20;
var RadioTextSize = (_a = {},
    _a['small'] = design_system_theme_1.FontSizes.fontSize14,
    _a['medium'] = design_system_theme_1.FontSizes.fontSize16,
    _a);
var RadioInput = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  appearance: none;\n  background-color: transparent;\n  margin: 0 0 0 15px;\n  width: ", "px;\n  height: ", "px;\n  border: ", ";\n  border-radius: 50%;\n  cursor: pointer;\n\n  &:before {\n    content: '';\n    display: inline-block;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 50%;\n    transform: scale(0);\n    transition: 0.1s transform ease-in-out;\n    background-color: ", ";\n  }\n\n  &:checked {\n    border: ", ";\n  }\n\n  &:checked::before {\n    transform: scale(1);\n  }\n\n  &:focus {\n    background-color: ", ";\n  }\n\n  &:focus-visible {\n    outline: none;\n  }\n\n  &:disabled {\n    background-color: ", ";\n  }\n"], ["\n  appearance: none;\n  background-color: transparent;\n  margin: 0 0 0 15px;\n  width: ", "px;\n  height: ", "px;\n  border: ", ";\n  border-radius: 50%;\n  cursor: pointer;\n\n  &:before {\n    content: '';\n    display: inline-block;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 50%;\n    transform: scale(0);\n    transition: 0.1s transform ease-in-out;\n    background-color: ", ";\n  }\n\n  &:checked {\n    border: ", ";\n  }\n\n  &:checked::before {\n    transform: scale(1);\n  }\n\n  &:focus {\n    background-color: ", ";\n  }\n\n  &:focus-visible {\n    outline: none;\n  }\n\n  &:disabled {\n    background-color: ", ";\n  }\n"])), RADIO_SIZE, RADIO_SIZE, function (_a) {
    var theme = _a.theme;
    return "1px solid ".concat(theme.colors.border.secondary);
}, RADIO_SIZE - 2, RADIO_SIZE - 2, function (_a) {
    var theme = _a.theme;
    return theme.colors.brand.primary;
}, function (_a) {
    var theme = _a.theme;
    return "1px solid ".concat(theme.colors.border.primary);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.background.secondary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.background.disabled;
});
var RadioLabel = (0, styled_components_1.default)(typography_1.BodyText).attrs(function (_a) {
    var $size = _a.$size, $disabled = _a.$disabled, theme = _a.theme;
    return ({
        color: $disabled ? theme.colors.text.disabled : theme.colors.text.primary,
        sizes: [RadioTextSize[$size]],
        forwardedAs: 'label',
    });
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n  min-height: ", "px;\n  cursor: pointer;\n  position: relative;\n  border-radius: 12px;\n  justify-content: space-between;\n\n  &:hover input:not(:checked):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:has(", ":focus-visible) {\n    outline: ", ";\n    outline-offset: 2px;\n  }\n\n  // Firefox does not currently support :has(), so this is used as a fallback\n  @-moz-document url-prefix() {\n    :focus-within {\n      outline: ", ";\n      outline-offset: 2px;\n    }\n  }\n\n  ", "\n\n  ", "\n\n  ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n  min-height: ", "px;\n  cursor: pointer;\n  position: relative;\n  border-radius: 12px;\n  justify-content: space-between;\n\n  &:hover input:not(:checked):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:has(", ":focus-visible) {\n    outline: ", ";\n    outline-offset: 2px;\n  }\n\n  // Firefox does not currently support :has(), so this is used as a fallback\n  @-moz-document url-prefix() {\n    :focus-within {\n      outline: ", ";\n      outline-offset: 2px;\n    }\n  }\n\n  ", "\n\n  ", "\n\n  ", ";\n"])), RADIO_SIZE, function (_a) {
    var theme = _a.theme;
    return theme.colors.background.secondary;
}, RadioInput, function (_a) {
    var theme = _a.theme;
    return "2px solid ".concat(theme.colors.outline.focus);
}, function (_a) {
    var theme = _a.theme;
    return "2px solid ".concat(theme.colors.outline.focus);
}, function (_a) {
    var bordered = _a.bordered, theme = _a.theme;
    return bordered && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.colors.background.input);
}, function (_a) {
    var $disabled = _a.$disabled;
    return $disabled && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      cursor: not-allowed;\n    "], ["\n      cursor: not-allowed;\n    "])));
}, function (_a) {
    var bordered = _a.bordered, $disabled = _a.$disabled, $checked = _a.$checked, theme = _a.theme;
    return bordered && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding: 14px 12px;\n      border: 1px solid ", ";\n\n      // Change the border color if the label has a child radio element which is checked\n      &:has(input:checked) {\n        border-color: ", ";\n      }\n\n      ", "\n\n      // Change the background color if the radio is both bordered and disabled\n      ", "\n    "], ["\n      padding: 14px 12px;\n      border: 1px solid ", ";\n\n      // Change the border color if the label has a child radio element which is checked\n      &:has(input:checked) {\n        border-color: ", ";\n      }\n\n      ", "\n\n      // Change the background color if the radio is both bordered and disabled\n      ", "\n    "])), theme.colors.border.secondary, theme.colors.border.primary, $checked && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        border-color: ", ";\n      "], ["\n        border-color: ", ";\n      "])), theme.colors.border.primary), $disabled && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), theme.colors.background.skeleton));
});
/**
 * A basic radio input.
 *
 * If rendering more than one radio for a given subject, the radios should live within a `Fieldset`.
 */
exports.Radio = (0, react_1.forwardRef)(function (_a, ref) {
    var labelText = _a.labelText, _b = _a.size, size = _b === void 0 ? 'small' : _b, bordered = _a.bordered, disabled = _a.disabled, checked = _a.checked, props = __rest(_a, ["labelText", "size", "bordered", "disabled", "checked"]);
    return (react_1.default.createElement(RadioLabel, { "$size": size, bordered: bordered, "$disabled": disabled, "$checked": checked },
        labelText,
        react_1.default.createElement(RadioInput, __assign({ type: "radio", disabled: disabled, ref: ref, checked: checked }, props))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
